<template>
  <div id="overlay" @click="closeGallery">
    <div class="lightbox-wrapper" @click.stop>
      <div class="super-img-block">
        <div class="counter">
          <p class="count-box">
            <span>{{selectedimageURLindex+1}} /</span>
            <span>{{imagesList ? imagesList.length : 0}}</span>
          </p>
        </div>
        <span class="prev-img-container" v-if="selectedimageURLindex > 0" @click.stop="prevImage">
          <a class="prev">
            <i class="icon-left-open"></i>
          </a>
        </span>

        <ul>
          <li>
            <img :src="imagesList[selectedimageURLindex] && imagesList[selectedimageURLindex].transformedImages.responsivedetailslargeimg.url" alt="overlay" />
          </li>
        </ul>
        <span class="next-img-container" v-if="selectedimageURLindex < imagesList.length - 1" @click.stop="nextImage">
          <a class="next">
            <i class="icon-right-open"></i>
          </a>
        </span>

      </div>
      <div class="banners-list">
        <div class="button-carousel left">
          <a class="prev" @click.stop="prevThumb" :class="disablePrev">
            <i class="icon-left-open"></i>
          </a>
        </div>
        <div class="thumbnails">
          <ul style="transition: all 2s ease;">
            <li v-for="(image, $index) in imagesList" :key="$index">
              <a @click.stop="showThumb($index)">
                <img :src="image.transformedImages.responsivedetailsthumbimg.url" alt="overlay" class="galleryThumbImg" :class="{'selected': selectedimageURLindex == $index}" />
              </a>
            </li>
          </ul>
        </div>
        <div class="button-carousel right">
          <a class="next" @click.stop="nextThumb" :class="disableNext">
            <i class="icon-right-open"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      selectedimageURLindex: 0,
      imagesPerStrip: 7,
      transformX: 0,
      imagesLeft: 0,
      imagesRight: 0
    }
  },
  props: {
    imagesList: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    }
  },
  watch: {
    imagesList: function(newValue) {
      this.imagesRight = newValue.length > this.imagesPerStrip ? newValue.length - this.imagesPerStrip : 0
    }
  },
  computed: {
    disablePrev: function() {
      if (this.imagesLeft <= 0) return { disabledBtn: true }
    },
    disableNext: function() {
      if (this.imagesRight <= 0) return { disabledBtn: true }
    }
  },
  methods: {
    isActive: function(index) {
      if (this.selectedimageURLindex == index) return { selected: true }
    },
    prevImage: function() {
      this.selectedimageURLindex--
      if (this.selectedimageURLindex > -1 && this.selectedimageURLindex < this.imagesLeft && this.imagesLeft > 0) {
        this.imagesLeft--
        this.imagesRight++
        this.style(1, 'prev')
      }
    },
    nextImage: function() {
      this.selectedimageURLindex++
      if (this.imagesPerStrip - 1 < this.selectedimageURLindex && this.selectedimageURLindex < this.imagesList.length && this.imagesRight > 0) {
        this.imagesRight--
        this.imagesLeft++
        this.style(1, 'next')
      }
    },
    showThumb: function(index) {
      this.selectedimageURLindex = index
      // if (imageType == 'image') {
      //   if (document.querySelectorAll('.super-img-block iframe')[index]) document.querySelectorAll('.super-img-block iframe')[index].src = ''
      // }
      // if (imageType == 'video') {
      // }
    },
    style: function(count, direction) {
      if (direction === 'prev') this.transformX = this.transformX + count * 120
      else this.transformX = this.transformX - count * 120
      document.querySelector('.thumbnails > ul').style.position = 'relative'
      document.querySelector('.thumbnails > ul').style.left = this.transformX + 'px'
    },
    prevThumb: function() {
      if (this.imagesLeft <= 0) return
      if (this.imagesLeft < this.imagesPerStrip) {
        this.style(this.imagesLeft, 'prev')
        this.imagesRight = this.imagesRight + this.imagesLeft
        this.imagesLeft = 0
      } else {
        this.style(this.imagesPerStrip, 'prev')
        this.imagesRight = this.imagesRight + this.imagesPerStrip
        this.imagesLeft = this.imagesLeft - this.imagesPerStrip
      }
    },
    nextThumb: function() {
      if (this.imagesRight <= 0) return
      if (this.imagesRight < this.imagesPerStrip) {
        this.style(this.imagesRight, 'next')
        this.imagesLeft = this.imagesRight + this.imagesLeft
        this.imagesRight = 0
      } else {
        this.style(this.imagesPerStrip, 'next')
        this.imagesLeft = this.imagesLeft + this.imagesPerStrip
        this.imagesRight = this.imagesRight - this.imagesPerStrip
      }
    },
    closeGallery: function() {
      this.$parent.showGallery = !this.$parent.showGallery
      document.getElementsByTagName('html')[0].style.overflowY = 'auto'
    }
  },
  mounted: function() {
    if (this.imagesList && this.imagesList.length > 0) {
      this.imagesList.forEach(mediaObj => {
        let imgObj = new Image()
        imgObj.src = mediaObj.transformedImages.responsivedetailslargeimg.url
      })
    }
    document.querySelector('.thumbnails').setAttribute('data-imgwidth', 120)
    this.imagesRight = this.imagesList.length > this.imagesPerStrip ? this.imagesList.length - this.imagesPerStrip : 0
  }
}
</script>
<style lang="scss" scoped>
.disabledBtn {
  opacity: 0.5;
  cursor: default !important;
}
.selected {
  border: 2px solid white;
}

.change-img-container {
  position: absolute;
  top: 0px;
  bottom: 35px;
  width: 40px;
}
.next-img-container {
  @extend .change-img-container;
  right: 0px;

  // &:hover {
  //   background: linear-gradient(to left, black, #5a5a5a);
  //   opacity: 0.7;
  // }
}

.prev-img-container {
  @extend .change-img-container;
  left: 0px;

  // &:hover {
  //   background: linear-gradient(to right, black, #5a5a5a);
  //   opacity: 0.7;
  // }
}

.prev:hover,
.next:hover {
  background: black;
}

.super-img-block:hover {
  .prev,
  .next {
    visibility: initial;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/gallery.vue